import { NamespacedStoreState, StoreState } from '@Types/store.types';

import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';

export const getStore = (state: NamespacedStoreState): NamespacedStoreState =>
	state;
export const getValue = (state: NamespacedStoreState): StoreState =>
	state[moduleNamespace];
export const areSystemConnectionsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].systemConnections.initialized;
export const areUsersInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].users.initialized;
export const areGeneralSettingsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].companySettings.initialized;
export const areProductsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].products.initialized;
export const areConfigurationsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].configurations.initialized;
export const areSensorsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].sensors.initialized;

export const useIsEntitlementsInitialized = () =>
	useSelector(
		createSelector(
			[areUsersInitialized, areProductsInitialized],
			(users, products) => users && products,
		),
	);

export const useIsGeneralSettingsInitialized = () =>
	useSelector(
		createSelector(
			[areGeneralSettingsInitialized],
			generalSettings => generalSettings,
		),
	);

export const useIsSystemConnectionsInitialized = () =>
	useSelector(
		createSelector(
			[areSystemConnectionsInitialized],
			systemConnections => systemConnections,
		),
	);
export const useIsConfigurationsInitialized = () =>
	useSelector(
		createSelector(
			[areConfigurationsInitialized],
			configurations => configurations,
		),
	);
export const useIsSensorsInitialized = () =>
	useSelector(createSelector([areSensorsInitialized], sensors => sensors));
